import { render, staticRenderFns } from "./ProductContentClassesTab.vue?vue&type=template&id=87f16282&scoped=true&"
import script from "./ProductContentClassesTab.vue?vue&type=script&lang=js&"
export * from "./ProductContentClassesTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentClassesTab.vue?vue&type=style&index=0&id=87f16282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f16282",
  null
  
)

export default component.exports